import { object, string } from "yup";
import { Fragments } from "requests";

export const getClientInformation = ({
  client
}: Fragments.StoredMedicalCase) => ({
  accountNumber: client?.accountNumber || "",
  email: client?.email || "",
  firstName: client?.firstName || "",
  lastName: client?.lastName || "",
  streetAddress: client?.streetAddress || "",
  apartments: client?.apartments || "",
  state: client?.state || null,
  city: client?.city || null,
  zipCode: client?.zipCode || null,
  phoneFirst: client?.phoneFirst || "",
  phoneSecond: client?.phoneSecond || "",
  notAvailableTime: client?.notAvailableTime || ""
});

export const getValidationSchema = () => {
  return object({
    accountNumber: string(),
    email: string().email(),
    firstName: string(),
    lastName: string(),

    streetAddress: string(),
    apartments: string(),
    state: string().nullable(),
    city: string().nullable(),
    zipCode: string().nullable(),
    phoneFirst: string(),
    phoneSecond: string(),
    notAvailableTime: string()
  });
};
